import { useEffect, useState } from "react";
import formatAddressDetails from "./useAddressDetails";

const useClientAddress = (clientDetail) => {
    
        const [billAdd, setBillAdd] = useState({
        city: "",
        state: "",
        country: "",
      });
      const [shipAdd, setShipAdd] = useState({
        city: "",
        state: "",
        country: "",
      });
    
      useEffect(() => {
        const fetchAddressDetails = async () => {
          const bill = await formatAddressDetails(clientDetail?.add);
          const ship = await formatAddressDetails(clientDetail?.spAd);
    
          setBillAdd(bill);
          setShipAdd(ship);
    
        };
        if (clientDetail?.add || clientDetail?.spAd) {
          fetchAddressDetails();
        }
      }, [clientDetail]);

      return {
        billAdd,
        shipAdd
      }
  };
  export default useClientAddress;